import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, withProps } from 'recompose';
import { partial } from 'lodash';
import List from './components/List';
import withFetchDataLoader from '../../../common/hoc/withFetchDataLoader';
import * as actions from './actions';
import { getServiceCategories } from './selectors';
import { getShopBrandId, isBrandViewActive } from '../../../auth/selectors';

const mapStateToProps = (state, ownProps) => ({
  shop: state.auth.shop,
  barberUser: state.auth.barberUser,
  items: getServiceCategories(state),
  baseUrl: ownProps.location.pathname,
  brandId: getShopBrandId(state),
  isBrandUser: isBrandViewActive(state),
});

const mapDispatchToProps = {
  fetchData: actions.fetchAllItems,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withProps(ownProps => ({ fetchData: partial(ownProps.fetchData, ownProps.brandId) })),
  withFetchDataLoader,
)(List);

